$('#comparisonSliderList').slick({
    mobileFirst: true,
    // variableWidth: false,
    dots: false,
    arrows: true,
    infinite: false,
    speed: 100,
    fade: true,
    cssEase: 'ease-in',
    // centerMode: true,
    // slidesToShow: 1,
    // initialSlide: 0,
    prevArrow: '<div class="slick-prev slick-arrow"><svg class="icon"><use xlink:href="svg/sprite.svg#MINUS"/></svg></div>',
    nextArrow: '<div class="slick-next slick-arrow"><svg class="icon"><use xlink:href="svg/sprite.svg#PLUS"/></svg></div>'
});